import { useMutation, useQueryClient } from "@tanstack/react-query";
import { api } from "@/lib/api";
import { queryKeys } from "@/lib/queryClient";
import type { Board, UUID } from "@/lib/types";

interface Vars {
  boardId: UUID;
  /** The source board's workspace — the copy lands here; used only to invalidate lists. */
  workspaceId: UUID;
  name?: string;
}

/** Duplicate a whole board into the same workspace. Returns the new board so the
 * caller can navigate to it; mirrors useCreateBoard's cache handling. */
export function useDuplicateBoard() {
  const qc = useQueryClient();
  return useMutation<Board, Error, Vars>({
    mutationFn: ({ boardId, name }) => api.duplicateBoard(boardId, name),
    onSuccess: (board) => {
      qc.setQueryData<Board[]>(queryKeys.boards(board.workspace_id), (prev) =>
        prev ? [board, ...prev] : [board],
      );
      void qc.invalidateQueries({ queryKey: queryKeys.boards(board.workspace_id) });
      void qc.invalidateQueries({ queryKey: queryKeys.myBoards });
    },
  });
}
